import React from 'react'
import PropTypes from 'prop-types'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/core/styles'
import ChoiceStartModal from 'components/choice-start-modal'
import { getCoachAvatarFontSize } from 'components/coach-user-avatar'
import { getInitials } from 'lib/text-display'
import { formatLocationLine } from './your-coaches/utils'

const AVATAR_SIZE = 56

const useStyles = makeStyles({
  coachAvatar: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    fontSize: getCoachAvatarFontSize(AVATAR_SIZE),
    fontWeight: 500,
    color: '#00205B',
    backgroundColor: '#E8F1FF',
    textTransform: 'uppercase',
  },
})

const getCoachDescription = coach =>
  coach.facilityName ||
  formatLocationLine(coach) ||
  'Book a lesson with this coach'

const CoachOptionAvatar = ({ coach, classes }) => (
  <Avatar
    className={classes.coachAvatar}
    alt={coach.name}
    src={coach.coachAvatar}
  >
    {getInitials(coach.name)}
  </Avatar>
)

const SelectCoachModal = ({ open, onClose, coaches, onSelectCoach }) => {
  const classes = useStyles()

  return (
    <ChoiceStartModal
      open={open}
      onClose={onClose}
      title="Book a session"
      subtitle="Select a coach to schedule your next lesson."
      columns={coaches.length >= 3 ? 3 : 2}
      options={coaches.map(coach => ({
        id: coach.id,
        visual: <CoachOptionAvatar coach={coach} classes={classes} />,
        title: coach.name,
        description: getCoachDescription(coach),
        onClick: () => onSelectCoach(coach),
      }))}
    />
  )
}

SelectCoachModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  coaches: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectCoach: PropTypes.func.isRequired,
}

export default SelectCoachModal
